"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateTransferBatch = /** @class */ (function () {
    function CreateTransferBatch(batch) {
        var _this = this;
        this.setQuantity = function (quantity) {
            _this.quantity = quantity;
        };
        this.setFromLocationInventory = function (fromLocationInventory) {
            _this.fromLocationInventory = fromLocationInventory;
        };
        this.setToLocationInventory = function (toLocationInventory) {
            _this.toLocationInventory = toLocationInventory;
        };
        this.batchId = batch.batchId;
        this.batchNumber = batch.batchNumber;
        this.quantityRemaining = batch.quantityRemaining;
        this.quantity = batch.quantity;
    }
    __decorate([
        mobx_1.observable
    ], CreateTransferBatch.prototype, "batchId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferBatch.prototype, "batchNumber", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferBatch.prototype, "quantityRemaining", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferBatch.prototype, "quantity", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferBatch.prototype, "fromLocationInventory", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferBatch.prototype, "toLocationInventory", void 0);
    __decorate([
        mobx_1.action
    ], CreateTransferBatch.prototype, "setQuantity", void 0);
    __decorate([
        mobx_1.action
    ], CreateTransferBatch.prototype, "setFromLocationInventory", void 0);
    __decorate([
        mobx_1.action
    ], CreateTransferBatch.prototype, "setToLocationInventory", void 0);
    return CreateTransferBatch;
}());
exports.CreateTransferBatch = CreateTransferBatch;
var CreateBatchOptions = /** @class */ (function () {
    function CreateBatchOptions(batches) {
        var _this = this;
        this.showHiddenBatch = false;
        this.setBatches = function (batches) {
            _this.batches = batches;
        };
        this.setBatchOption = function (option) {
            _this.selectedBatch = option;
        };
        this.toggleHiddenBatch = function () {
            _this.showHiddenBatch = !_this.showHiddenBatch;
            // Reset the selectedBatchOption when 0 or negative batch has been selected but not displaying them
            if (_this.isSelectedBatchNull) {
                _this.setBatchOption(null);
            }
        };
        this.batches = batches;
    }
    Object.defineProperty(CreateBatchOptions.prototype, "options", {
        get: function () {
            var _this = this;
            var newBatches = this.batches;
            // Hide 0 or negative batches
            if (!this.showHiddenBatch) {
                newBatches = newBatches.filter(function (batch) { return batch.quantityRemaining > 0; });
            }
            // Sort descending order by quantity
            newBatches = newBatches.sort(function (a, b) {
                if (b.quantityRemaining > a.quantityRemaining)
                    return 1;
                if (b.quantityRemaining < a.quantityRemaining)
                    return -1;
                return 0;
            });
            return newBatches.map(function (batch) { return ({
                label: "" + batch.batchNumber,
                unit: batch.quantityRemaining + " " + (Math.abs(batch.quantityRemaining) > 1 ? 'units' : 'unit'),
                value: batch.id,
                data: batch,
                selected: _this.selectedBatch ? _this.selectedBatch.value === batch.id : false,
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateBatchOptions.prototype, "isSelectedBatchNull", {
        get: function () {
            var selectedBatch = this.selectedBatch;
            if (!selectedBatch) {
                return true;
            }
            var filtered = this.options.filter(function (option) { return option.value === selectedBatch.value; });
            if (filtered.length < 1) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateBatchOptions.prototype, "batches", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBatchOptions.prototype, "selectedBatch", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBatchOptions.prototype, "showHiddenBatch", void 0);
    __decorate([
        mobx_1.action
    ], CreateBatchOptions.prototype, "setBatches", void 0);
    __decorate([
        mobx_1.action
    ], CreateBatchOptions.prototype, "setBatchOption", void 0);
    __decorate([
        mobx_1.action
    ], CreateBatchOptions.prototype, "toggleHiddenBatch", void 0);
    __decorate([
        mobx_1.computed
    ], CreateBatchOptions.prototype, "options", null);
    __decorate([
        mobx_1.computed
    ], CreateBatchOptions.prototype, "isSelectedBatchNull", null);
    return CreateBatchOptions;
}());
exports.CreateBatchOptions = CreateBatchOptions;
//# sourceMappingURL=Batch.js.map